import { QueryBuilderBase } from './QueryBuilderBase';

export class IntegerQueryBuilder extends QueryBuilderBase {

  static get Operators() {
    return {
      EQUAL_TO: {
        name: 'is equal to',
        operator: '$eq',
      },
      NOT_EQUAL_TO: {
        name: 'is not equal to',
        operator: '$ne',
      },
      LESS_THAN: {
        name: 'is less than',
        operator: '$lt',
      },
      GREATER_THAN: {
        name: 'is greater than',
        operator: '$gt',
      },
      LESS_THAN_OR_EQUAL_TO: {
        name: 'is less than or equal to',
        operator: '$lte',
      },
      GREATER_THAN_OR_EQUAL_TO: {
        name: 'is greater than or equal to',
        operator: '$gte',
      },
    };
  }

  buildCondition(fieldName, operand) {
    if (operand === undefined) return this.query;

    const condition = {};

    // Identify the operator group from the object above
    const operatorGroup = this.constructor.OperatorList
      .find(operatorKey => {
        return operatorKey.name === this.operator;
      });

    const feathersOperator = operatorGroup.operator;

    condition[fieldName] = { [feathersOperator]: operand };

    return condition;
  }
}
